module.exports = __webpack_public_path__ + "static/media/DIA.b8f29a5b.png";